export const environment = {
  production: false,
  environment: 'staging',
  useAuthInterceptor: false,
  title: 'Inventa DEV',
  username: '',
  desktop: false,
  mobile: false,
  baseRef: null,
  gmak: false,
  keycloakUrl: window['env']['keycloakUrl'],
  keycloakRealm: window['env']['keycloakRealm'],
  keycloakClientId: window['env']['keycloakClientId'],
  backendHost: window['env']['backendHost'],
  myVectronicUrl: 'https://my.dev-env.vectronic.de/',
  esriClientId: 'XHWdcsdGhCqr8ppe',
  esriPortalUrl: 'https://vectronic.maps.arcgis.com',
  gitlabApiReadPackageToken: 'Nvt7zHUaRk8uFkeVBtDg',
};
